<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <cms-component-text comp-id="title" :component="block.title" placeholder="Title|Titre" v-bind="componentProps"/>
        <cms-component-text comp-id="subtitle" :component="block.subtitle" placeholder="Subtitle|Sous-titre" v-bind="componentProps"/>
        <cms-component-text comp-id="description" :component="block.description" placeholder="Description" v-bind="componentProps"/>
        <cms-component-button comp-id="button" :component="block.button" placeholder="Button|Bouton" v-bind="componentProps"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentButton from "@/components/editor/rendering/components/cms-component-button.vue";
import CmsComponentText from "@/components/editor/rendering/components/cms-component-text.vue";

// cms-block-title #hot-reload-debug
export default {
    name: `cms-block-title`,
    components: {CmsComponentButton, CmsComponentText, CmsBlock},
    extends: CmsBlock
}
</script>

<style lang="scss" scoped>
</style>
